import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';

class Sidebar extends Component {
    render() {
        const role = localStorage.getItem('role') || 'admin_akademik';

        return (
            <nav className="sidebar sidebar-offcanvas" id="sidebar">
                <ul className="nav">
                    {/* Home - Semua role */}
                    <li className="nav-item">
                        <Link className="nav-link" to="/home">
                            <i className="icon-grid menu-icon" />
                            <span className="menu-title">Home</span>
                        </Link>
                    </li>

                    {/* Mahasiswa Menu - Admin Akademik & Admin Prodi */}
                    {(role === 'admin_akademik' || role === 'admin_prodi') && (
                        <li className="nav-item" id="mahasiswaNav">
                            <a className="nav-link ikon" data-toggle="collapse" href="#mahasiswaOpen" aria-expanded="false" aria-controls="mahasiswa" id="mahasiswaLink">
                                <i className="ti-id-badge menu-icon" />
                                <span className="menu-title">Mahasiswa</span>
                                <i className="menu-arrow" />
                            </a>
                            <div className="collapse" id="mahasiswaOpen">
                                <ul className="nav flex-column sub-menu">
                                    <li className="nav-item">
                                        <NavLink activeClassName="underline" className="nav-link" to="/data-mahasiswa">Data Mahasiswa</NavLink>
                                    </li>
                                    {role === 'admin_akademik' && (
                                        <>
                                            <li className="nav-item">
                                                <NavLink activeClassName="underline" className="nav-link" to="/generate-pw">Generate Password</NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink activeClassName="underline" className="nav-link" to="/cek-krs">Cek KRS</NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink activeClassName="underline" className="nav-link" to="/status-mhs">Status Mahasiswa</NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink activeClassName="underline" className="nav-link" to="/history-mhs">History Mahasiswa</NavLink>
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </div>
                        </li>
                    )}

                    {/* Dosen Menu - Untuk role dosen */}
                    {role === 'dosen' && (
                        <li className="nav-item" id="dosenNav">
                            <a className="nav-link ikon" data-toggle="collapse" href="#dosenOpen" aria-expanded="false" aria-controls="dosen" id="dosenLink">
                                <i className="ti-user menu-icon" />
                                <span className="menu-title">Dosen</span>
                                <i className="menu-arrow" />
                            </a>
                            <div className="collapse" id="dosenOpen">
                                <ul className="nav flex-column sub-menu">
                                    <li className="nav-item">
                                        <NavLink activeClassName="underline" className="nav-link" to="/data-dosen">Profil Saya</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink activeClassName="underline" className="nav-link" to="/perwalian">Mahasiswa Perwalian</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    )}
                </ul>
            </nav>
        );
    }
}

export default Sidebar;
